import React from "react";
import { FlexColumn, FlexRow, Text } from "../../../styles/Global";
import * as Global from "../../../styles/Global";
import StatBlock from "../StatBlock";
import "../../../App.scss";

const ScoremagicStatsHorseshoes = ({
  data,
  viewType,
  showDPR,
  formatType,
  value,
}) => {
  console.log("scoremagicStatsHorseshoes data: ", data);
  return (
    <>
      {formatType !== "all" && value > 1 && (
        <FlexRow
          style={{ width: "100%", marginTop: 10 }}
          align="center"
          justify="center"
        >
          <Text
            style={{ fontStyle: "italic", textAlign: "center" }}
            size=".7em"
          >
            {formatType === "all"
              ? "Sandbag %"
              : formatType === "bracket"
              ? "Bracket stat"
              : "Round Robin stat"}{" "}
            tracking began in December 2023
          </Text>
        </FlexRow>
      )}
      <FlexRow
        style={{
          paddingBottom: 10,
          borderRadius: 20,
        }}
        justify="center"
      >
        <StatBlock
          topText={data.totalRounds}
          bottomText="Rounds"
          blur={viewType < 2}
        />
        <StatBlock topText={data.ppr} bottomText="PPR" blur={viewType < 2} />
        <StatBlock
          topText={data.oppr}
          bottomText="Opp PPR"
          blur={viewType < 2}
        />
        <StatBlock topText={data.dpr} bottomText="DPR" blur={viewType < 2} />
      </FlexRow>
      <FlexRow style={{ marginTop: 10 }} justify="center">
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.ring2Percent}%
              </Text>
              <Text size="13px">{data.ring2Total.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="2-R"
          blur={viewType < 2}
        />
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.ring1Percent}%
              </Text>
              <Text size="13px">{data.ring1Total.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="1-R"
          blur={viewType < 2}
        />
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.ring0Percent}%
              </Text>
              <Text size="13px">{data.ring0Total.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="0-R"
          blur={viewType < 2}
        />
      </FlexRow>
      <FlexRow style={{ marginTop: 10 }} justify="center">
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.allInPercent}%
              </Text>
              <Text size="13px">{data.allInTotal.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="Total Ringers"
          blur={viewType < 2}
        />
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.onPercent}%
              </Text>
              <Text size="13px">{data.onTotal.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="Singles"
          blur={viewType < 2}
        />
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.offPercent}%
              </Text>
              <Text size="13px">{data.offTotal.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="Miss"
          blur={viewType < 2}
        />
      </FlexRow>
      <FlexRow style={{ marginTop: 10 }} justify="center">
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.roundWinPercent}%
              </Text>
              <Text size="13px">{data.roundWinTotal.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="Round Win"
          blur={viewType < 2}
        />
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.roundLossPercent}%
              </Text>
              <Text size="13px">{data.roundLossTotal.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="Round Loss"
          blur={viewType < 2}
        />
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.roundTiePercent}%
              </Text>
              <Text size="13px">{data.roundTieTotal.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="Round Tie"
          blur={viewType < 2}
        />
        {formatType === "all" && (
          <StatBlock
            topText={
              <FlexColumn align="center">
                <Text size="20px" style={{ fontWeight: "700" }}>
                  {data.matchTypeDiffPercent}%
                </Text>
                <Text size="13px">{data.matchTypeDiff.toLocaleString()}</Text>
              </FlexColumn>
            }
            bottomText="SB%"
            blur={viewType < 2}
          />
        )}
      </FlexRow>
    </>
  );
};

export default ScoremagicStatsHorseshoes;
